function applyVisibilityStyles() {
  const elements = document.querySelectorAll('[data-visibility]');

  elements.forEach((element) => {
    const breakPoint =
      parseInt(element.getAttribute('data-visibility-breakpoint'), 10) || 1200;
    const windowWidth = window.innerWidth;
    const visibility = element.getAttribute('data-visibility');
    const isMobile = windowWidth < breakPoint;
    const isDesktop = windowWidth >= breakPoint;

    element.style.margin = '0 !important;';

    const shouldHide =
      (visibility === 'mobile' && !isMobile) ||
      (visibility === 'desktop' && !isDesktop);

    setTimeout(() => {
      element.classList.toggle('is-hidden-by-visibility-script', shouldHide);
    }, 150);
  });
}

let resizeTimeout;
function handleResize() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(applyVisibilityStyles, 150);
}

window.addEventListener('DOMContentLoaded', applyVisibilityStyles);
window.addEventListener('resize', handleResize);
